import { Directive,Input,OnInit,HostListener,Inject} from '@angular/core';
import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service'

@Directive({
	selector: '[abs-set-next-focus]'
})
export class AbsSetNextFocusDirective implements OnInit {
	firstFocusableElement;
	selectorsArray;
	@Input('abs-set-next-focus') selectors:string;
	@Input('set-next-focus-index') index:number;
	@HostListener('click') setNextFocus() {
		let i = 0;
		let containerEl;
		do {
			containerEl = document.querySelectorAll(this.selectorsArray[i])[this.index];
			i++;
		} while ( !containerEl && (i < this.selectorsArray.length));
		if (containerEl) {
			this.firstFocusableElement = this.domHelper.firstTabableElement(containerEl);
			if (this.firstFocusableElement) {
				this.firstFocusableElement.focus();
			}
		}
	}
	constructor(
		@Inject(AbsDomHelperService) private domHelper:AbsDomHelperService
	) { }
	ngOnInit() {
		if (this.selectors) {
			this.selectorsArray = this.selectors.split(' ');
		}
		this.index = this.index | 0;
	}
}
